// import React, { useState, useEffect } from "react";
// import "../../components/DashboardModule/MyOrder.css";
// import PaymentModal from "./PaymentModal";
// import { getBuyerMyOrderConfirmList } from "../../API/Api";
// import { MoreVertical } from "lucide-react";
// import TrackingOrder from "./TrackingOrder";

// const MyOrder = () => {
// 	const [isModalOpen, setIsModalOpen] = useState(false);
// 	const [currentOrderId, setCurrentOrderId] = useState(null);
// 	const [uploadedFiles, setUploadedFiles] = useState({});
// 	const [orders, setOrders] = useState([]);
// 	const [showTracking, setShowTracking] = useState(false);
// 	const [currentQuotationId, setCurrentQuotationId] = useState(null);
// 	useEffect(() => {
// 		const fetchOrders = async () => {
// 			try {
// 				const response = await getBuyerMyOrderConfirmList();
// 				if (response.status) {
// 					setOrders(response.data);
// 				} else {
// 					console.error("Failed to fetch orders");
// 				}
// 			} catch (error) {
// 				console.error("Error fetching orders:", error);
// 			}
// 		};

// 		fetchOrders();
// 	}, []);

// 	const toggleModal = (orderId) => {
// 		setCurrentOrderId(orderId);
// 		setIsModalOpen(!isModalOpen);
// 	};

// 	const handleFileUpload = (orderId, file) => {
// 		setUploadedFiles((prevState) => ({
// 			...prevState,
// 			[orderId]: file,
// 		}));
// 	};

// 	const handleConfirm = (orderId) => {
// 		console.log(`Confirmed for order: ${orderId}`);
// 		setIsModalOpen(false);
// 	};

// 	return (
// 		<div className="order-container-ord">
// 			<table className="order-table-ord font-poppins">
// 				<thead>
// 					<tr>
// 						<th className="order-col-ord">Order ID</th>
// 						<th className="order-col-ord">Product Details</th>
// 						<th className="order-col-ord">Brand Name</th>
// 						<th className="order-col-ord">Status</th>
// 						<th className="order-col-ord">Action</th>
// 					</tr>
// 				</thead>
// 				<tbody>
// 					{orders.map((order) => (
// 						<tr key={order.enquiry_reference_number}>
// 							<td className="order-col-ord">{order.enquiry_reference_number}</td>
// 							<td className="order-col-ord">{order.product_details.product_name}</td>
// 							<td className="order-col-ord">
// 								{order.brands.map((brand) => brand.name).join(", ")}
// 							</td>
// 							<td className="order-col-ord">{order.tracking_status}</td>
// 							<td>
// 								<div className="quo-action-menu">
// 									<MoreVertical />
// 									<div className="quo-dropdown">
// 										<button
// 											className="text-quo font-poppins"
// 											onClick={() => {
// 												setCurrentOrderId(order.enquiry_reference_number);
// 												setCurrentQuotationId(order.quotation_id);
// 												setShowTracking(true);
// 											}}
// 										>
// 											Preview
// 										</button>
// 									</div>
// 								</div>
// 							</td>
// 						</tr>
// 					))}
// 				</tbody>
// 			</table>

// 			<PaymentModal
// 				isOpen={isModalOpen}
// 				onClose={() => setIsModalOpen(false)}
// 				orderId={currentOrderId}
// 				onFileUpload={handleFileUpload}
// 				onConfirm={handleConfirm}
// 			/>

// 			{showTracking && (
// 				<div className="tracking-modal-overlay">
// 					<div className="tracking-modal">
// 						<TrackingOrder
// 							orderId={currentOrderId}
// 							quotationId={currentQuotationId}
// 							onClose={() => setShowTracking(false)}
// 						/>
// 					</div>
// 				</div>
// 			)}
// 		</div>
// 	);
// };

// export default MyOrder;


import React, { useState, useEffect } from "react";
import "../../components/DashboardModule/MyOrder.css";
import PaymentModal from "./PaymentModal";
import { getBuyerMyOrderConfirmList } from "../../API/Api";
import { MoreVertical, Download } from "lucide-react";
import TrackingOrder from "./TrackingOrder";
import UploadPOBuyer from "./UploadPOBuyer";
import { toast } from "react-toastify";
import { IoCloudUpload, IoCloudDownloadSharp } from "react-icons/io5";
import { MdPreview } from "react-icons/md";


const MyOrder = () => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [currentOrderId, setCurrentOrderId] = useState(null);
	const [uploadedFiles, setUploadedFiles] = useState({});
	const [orders, setOrders] = useState([]);
	const [showTracking, setShowTracking] = useState(false);
	const [currentQuotationId, setCurrentQuotationId] = useState(null);
	const [showUploadPO, setShowUploadPO] = useState(false);

	useEffect(() => {
		const fetchOrders = async () => {
			try {
				const response = await getBuyerMyOrderConfirmList();
				if (response.status) {
					setOrders(response.data);
				} else {
					console.error("Failed to fetch orders");
				}
			} catch (error) {
				console.error("Error fetching orders:", error);
			}
		};

		fetchOrders();
	}, []);

	const toggleModal = (orderId) => {
		setCurrentOrderId(orderId);
		setIsModalOpen(!isModalOpen);
	};

	const handleFileUpload = (orderId, file) => {
		setUploadedFiles((prevState) => ({
			...prevState,
			[orderId]: file,
		}));
	};

	const handleConfirm = (orderId) => {
		console.log(`Confirmed for order: ${orderId}`);
		setIsModalOpen(false);
	};

	const handleUploadSuccess = () => {
		setShowUploadPO(false);
	};

	const handleDownloadPO = (piFileUrl) => {
		if (!piFileUrl) {
			toast.error("No PO file available for download");
			return;
		}

		const link = document.createElement("a");
		link.href = piFileUrl;
		link.target = "_blank";
		link.rel = "noopener noreferrer";
		link.download = piFileUrl.split("/").pop() || "purchase_order";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);

		toast.success("PO file download started");
	};

	return (
		<div className="order-container-ord" style={{ padding: 20 }}>
			<table className="order-table-ord font-poppins">
				<thead>
					<tr>
						<th className="order-col-ord">Order ID</th>
						<th className="order-col-ord">Product Details</th>
						<th className="order-col-ord">Brand Name</th>
						<th className="order-col-ord">Status</th>
						<th className="order-col-ord">Action</th>
					</tr>
				</thead>
				<tbody>
					{orders.map((order) => (
						<tr key={order.enquiry_reference_number}>
							<td className="order-col-ord">{order.enquiry_reference_number}</td>
							<td className="order-col-ord">
								{order.product_details?.product_name || "N/A"}
							</td>
							<td className="order-col-ord">
								{order.brands?.map((brand) => brand.name).join(", ") || "N/A"}
							</td>
							<td className="order-col-ord">{order.tracking_status || "N/A"}</td>
							<td>
								<div className="quo-action-menu">
									<MoreVertical />
									<div className="quo-dropdown">
										<button
											className="text-quo font-poppins"
											onClick={() => {
												setCurrentOrderId(order.enquiry_reference_number);
												setCurrentQuotationId(order.quotation_id);
												setShowTracking(true);
											}}
										>
											<div className="preview-label">
												<span>Preview</span>
												{/* <MdPreview size={14} /> */}
											</div>
										</button>
										{!order.po_file && (
											<button
												className="text-quo font-poppins"
												onClick={() => {
													setCurrentQuotationId(order.quotation_id);
													setShowUploadPO(true);
												}}
											>

												<div className="preview-label">
													<span>Upload PO</span>
													{/* <IoCloudDownloadSharp size={14} /> */}
												</div>
											</button>
										)}
										<button
											className="text-quo font-poppins"
											onClick={() => handleDownloadPO(order.pi_file)}
										>
											<div className="preview-label">
												<span>Download PO</span>
												{/* <IoCloudUpload size={16} /> */}
											</div>
										</button>
									</div>
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			<PaymentModal
				isOpen={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				orderId={currentOrderId}
				onFileUpload={handleFileUpload}
				onConfirm={handleConfirm}
			/>

			{showTracking && (
				<div className="tracking-modal-overlay">
					<div className="tracking-modal">
						<TrackingOrder
							orderId={currentOrderId}
							quotationId={currentQuotationId}
							onClose={() => setShowTracking(false)}
						/>
					</div>
				</div>
			)}

			<UploadPOBuyer
				isOpen={showUploadPO}
				onClose={() => setShowUploadPO(false)}
				quotationId={currentQuotationId}
				onUploadSuccess={handleUploadSuccess}
			/>
		</div>
	);
};

export default MyOrder;